// Copyright (c) StrangeBee 2024

import { useLocalMessage } from '@Helpers/locale';
import { QuickFiltersAvailable } from '@Hooks/useQuickFilters';
import StatsCard from '@Molecules/StatsCard/StatsCard';
import React from 'react';
import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { WidgetOutput, ObjectTypeV1 } from 'thehive-sdk';

import './ObservableStats.scss';

interface ObservableStatsProps {
    quickFilters: QuickFiltersAvailable;
}

const ObservableStats = ({ quickFilters }: ObservableStatsProps): ReactElement => {
    const i = useLocalMessage();
    const { caseId } = useParams<{ caseId: string }>();
    const { status: filterStatus, custom: filterCustom } = quickFilters;

    const datatypeWidget: WidgetOutput = {
        id: 'observable-stats-datatype',
        type: 'donut',
        options: {
            stacked: false,
            field: 'dataType',
            filters: [
                {
                    field: 'relatedId',
                    operator: 'any',
                    values: [caseId],
                    type: 'string',
                },
            ],
            entity: ObjectTypeV1.OBSERVABLE,
            periodDateField: '_createdAt',
        },
    };

    const iocWidget: WidgetOutput = {
        id: 'observable-stats-ioc',
        type: 'donut',
        options: {
            stacked: false,
            field: 'ioc',
            filters: [
                {
                    field: 'relatedId',
                    operator: 'any',
                    values: [caseId],
                    type: 'string',
                },
            ],
            entity: ObjectTypeV1.OBSERVABLE,
            periodDateField: '_createdAt',
        },
    };

    return (
        <div className="observable-display-stats">
            <StatsCard
                widget={datatypeWidget}
                onItemClick={(value) => filterStatus(value, 'dataType')}
                title={i('observable.stats.type')}
            />

            <StatsCard
                widget={iocWidget}
                onItemClick={(value) => filterCustom({ field: 'ioc', operator: value + '' })}
                title={i('observable.stats.ioc')}
            />
        </div>
    );
};

export default ObservableStats;
